module.exports = __webpack_public_path__ + "static/media/pr-2.ee9e45db.jpg";